import React from "react";
import { Link } from "react-router-dom";
import PolicyPage, { SupportEmail } from "./PolicyPage";

function Delivery() {
  return (
    <PolicyPage title="Shipping & Delivery Policy">
      <p>
        <strong>Processing and production</strong>
        <br />
        Ready-to-ship items are prepared after payment and fraud review.
        Made-to-order pieces generally require 6–8 weeks before dispatch.
        Customization, approvals, material availability, peak periods, or
        quality checks may extend the estimate. Processing time is separate from
        carrier transit time.
      </p>
      <p>
        <strong>Domestic shipping</strong>
        <br />
        Domestic orders ship at a USD $45 flat rate where this option is shown
        at checkout. Tracking is provided after dispatch and a signature is
        required. Orders valued at USD $500 or more may require an adult
        signature and additional high-value handling.
      </p>
      <p>
        <strong>International shipping</strong>
        <br />
        International shipping is available at a USD $75 flat rate to supported
        destinations where shown at checkout. We may decline destinations that
        present legal, carrier, insurance, or delivery limitations. Transit
        estimates do not include customs processing.
      </p>
      <p>
        <strong>Duties, taxes, and customs</strong>
        <br />
        Unless checkout expressly states that charges are included, the
        recipient is responsible for import duties, taxes, VAT, brokerage,
        handling, and other destination charges. We declare merchandise
        accurately and will not mark a commercial order as a gift or lower its
        value. Customs or the carrier may request information before release.
      </p>
      <p>
        <strong>Address accuracy and changes</strong>
        <br />
        Provide a complete address that can accept tracked, signature-required
        delivery. Contact us immediately to request a correction. A change is
        not effective until confirmed and cannot be guaranteed after packing or
        label creation. We may cancel an order if the destination cannot be
        verified or served safely.
      </p>
      <p>
        <strong>Tracking and delivery</strong>
        <br />
        A tracking notice means the carrier has received shipment information;
        scans may take time to appear. Delivery estimates are not guaranteed
        unless a guaranteed service is expressly stated. A signature or other
        carrier proof may be treated as evidence of delivery, subject to
        mandatory consumer law.
      </p>
      <p>
        <strong>Delays outside reasonable control</strong>
        <br />
        Weather, customs, transportation disruption, labor action, public
        emergency, remote-area service, incorrect address data, or carrier
        security measures may cause delay. We will provide available information
        and reasonable assistance, but are not responsible for delay outside our
        reasonable control except where law provides otherwise.
      </p>
      <p>
        <strong>Failed delivery, refusal, and return to sender</strong>
        <br />
        Carriers may make limited delivery attempts or hold a parcel for pickup.
        If a parcel is returned because the address was incorrect, delivery was
        refused, it was not collected, or destination charges were unpaid,
        reasonable return, customs, storage, and redelivery costs may be charged
        or deducted from an eligible refund where lawful.
      </p>
      <p>
        <strong>Loss, damage, and tampering</strong>
        <br />
        If tracking stalls, the parcel is delivered to the wrong place, or the
        package appears damaged or opened, contact the carrier and <SupportEmail />
        promptly. Preserve packaging and provide photographs. We may require a
        signed statement and reasonable cooperation with a carrier or insurer.
        Do not return damaged goods until instructed.
      </p>
      <p>
        <strong>Risk and ownership</strong>
        <br />
        Risk passes at the time required by applicable law. Nothing in this
        policy transfers carrier risk to a consumer earlier than mandatory law
        permits. Ownership may remain with us until payment is received in full,
        where lawful.
      </p>
      <p>
        <strong>Support</strong>
        <br />
        For shipping questions, email <SupportEmail />. Returns after delivery
        are governed by our <Link to="/returns">Refund &amp; Return Policy</Link>.
      </p>
    </PolicyPage>
  );
}

export default Delivery;
